/**
 * Selectable color palettes. Each preset is just a primary + secondary brand
 * hex — the full 50–900 shade scale is derived at runtime via
 * `generateColorScale` (see color.ts) and injected as CSS custom properties,
 * so any palette works with any design system.
 */
export type PalettePreset = {
	id: string;
	nameKey: string;
	primary: string;
	secondary: string;
};

export const PALETTE_PRESETS: PalettePreset[] = [
	{
		id: "violet",
		nameKey: "settings.appearance.palettes.violet",
		primary: "#7c3aed",
		secondary: "#f59e0b",
	},
	{
		id: "ocean",
		nameKey: "settings.appearance.palettes.ocean",
		primary: "#0284c7",
		secondary: "#14b8a6",
	},
	{
		id: "emerald",
		nameKey: "settings.appearance.palettes.emerald",
		primary: "#16a34a",
		secondary: "#84cc16",
	},
	{
		id: "rose",
		nameKey: "settings.appearance.palettes.rose",
		primary: "#e11d48",
		secondary: "#f97316",
	},
	{
		id: "sunset",
		nameKey: "settings.appearance.palettes.sunset",
		primary: "#ea580c",
		secondary: "#eab308",
	},
	{
		id: "slate",
		nameKey: "settings.appearance.palettes.slate",
		primary: "#475569",
		secondary: "#0ea5e9",
	},
];

export const CUSTOM_PALETTE_ID = "custom";

export const DEFAULT_CUSTOM_PRIMARY = "#7c3aed";
export const DEFAULT_CUSTOM_SECONDARY = "#f59e0b";

export function getPalettePreset(id: string): PalettePreset | undefined {
	return PALETTE_PRESETS.find((preset) => preset.id === id);
}
